import { render, staticRenderFns } from "./AddressCapture.vue?vue&type=template&id=a5232c72&scoped=true"
import script from "./AddressCapture.vue?vue&type=script&lang=js"
export * from "./AddressCapture.vue?vue&type=script&lang=js"
import "./AddressCapture.vue?vue&type=style&index=0&id=a5232c72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5232c72",
  null
  
)

export default component.exports